import { Link } from "@tanstack/react-router";
import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { UnscrambleForm } from "../components/UnscrambleForm";
import { WuBreadcrumb } from "../components/WuBreadcrumb";
import { WuExplainer } from "../components/WuExplainer";

const EXAMPLES = ["listen", "friend", "master", "silent", "garden", "planet"];

export function UnscrambleHub() {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <WuBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.wu_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.wu_hub_intro()}
          </p>
        </header>

        <UnscrambleForm />

        <section className="mt-8">
          <h2 className="mb-3 font-display text-lg font-semibold tracking-tight">
            {m.wu_examples_title()}
          </h2>
          <div className="flex flex-wrap gap-2">
            {EXAMPLES.map((w) => (
              <Link
                key={w}
                to="/word-unscrambler/$letters"
                params={{ letters: w }}
                className="rounded-md border border-border bg-card/40 px-3 py-1.5 text-sm font-medium transition-colors hover:border-primary/50 hover:bg-primary/10"
              >
                {w.toUpperCase()}
              </Link>
            ))}
          </div>
        </section>

        <WuExplainer
          howTo={m.wu_hub_howto()}
          faqs={[
            { q: m.wu_hub_faq1_q(), a: m.wu_hub_faq1_a() },
            { q: m.wu_hub_faq2_q(), a: m.wu_hub_faq2_a() },
            { q: m.wu_hub_faq3_q(), a: m.wu_hub_faq3_a() },
            { q: m.wu_hub_faq4_q(), a: m.wu_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
